/* ================================================== */
/* COMPONENTS → Video background
/* ================================================== */

$(document).ready(function() {

	// YouTube
	if ($('#youtubeVideo').length) {
		$('#youtubeVideo').YTPlayer();
	}

});